/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgPersistentVolume = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M2 9c0-.852.519-1.504 1.088-1.953.581-.458 1.36-.826 2.232-1.117C7.075 5.345 9.437 5 12 5c2.563 0 4.925.345 6.68.93.873.29 1.651.66 2.232 1.117C21.482 7.496 22 8.148 22 9v6c0 .852-.519 1.504-1.088 1.953-.58.458-1.36.826-2.232 1.117-1.755.585-4.117.93-6.68.93-2.563 0-4.924-.345-6.68-.93-.873-.29-1.65-.66-2.232-1.117C2.52 16.504 2 15.852 2 15zm2 0c0 .001 0 .006.003.015a.296.296 0 0 0 .032.066c.043.07.13.174.291.301.33.26.87.539 1.626.79C7.454 10.674 9.592 11 12 11s4.546-.327 6.048-.827c.756-.252 1.296-.53 1.626-.79.162-.128.249-.232.29-.302a.293.293 0 0 0 .033-.066A.053.053 0 0 0 20 9l-.003-.015a.293.293 0 0 0-.032-.066 1.235 1.235 0 0 0-.291-.301c-.33-.26-.87-.539-1.626-.79C16.546 7.326 14.408 7 12 7s-4.546.327-6.048.827c-.756.252-1.296.53-1.626.79a1.236 1.236 0 0 0-.29.302.296.296 0 0 0-.033.066L4 9zm16 2.527a9.532 9.532 0 0 1-1.32.543c-1.755.585-4.117.93-6.68.93-2.563 0-4.925-.345-6.68-.93A9.53 9.53 0 0 1 4 11.527V15l.003.015a.294.294 0 0 0 .032.066c.043.07.13.174.291.301.33.26.87.539 1.626.79C7.454 16.674 9.592 17 12 17s4.546-.327 6.048-.827c.756-.252 1.296-.53 1.626-.79.162-.128.249-.232.29-.302a.294.294 0 0 0 .033-.066L20 15z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgPersistentVolume as PersistentVolume };
